<template>
	<basic-container :block="currentStep === '0'">
		<el-steps :active="currentStep * 1" align-center finish-status="success">
			<el-step title="查验保单"></el-step>
			<el-step title="查验结果"></el-step>
		</el-steps>

		<el-tabs v-model="currentStep" tab-position="top">
			<el-tab-pane label="" name="0">
				<el-card class="u-m-t-20">
					<avue-form v-model="truthData" :option="truthOption" @submit="onSubmit">
						<template #idnos="{}">
							<div>
								请填写身份证号，多个身份证号请用“,“隔开，一次最多可查询10个身份证号例如：1101XXXXXXXXXXX698,1101XXXXXXXXXXX832
							</div>
							<el-input v-model="truthData.idnos" :rows="3" placeholder="请输入身份证号" type="textarea"></el-input>
						</template>
						<template #code="{}">
							<div class="u-flex u-col-center" style="height: 30px">
								<el-input v-model="truthData.code" style="max-width: 80px"></el-input>
								<el-image :src="imageUrl" style="width: 120px; height: 40px; margin: 0 10px"></el-image>
								<el-button :loading="isLoading" type="text" @click="onGetCode">换一个</el-button>
							</div>
						</template>
					</avue-form>
				</el-card>
			</el-tab-pane>
			<el-tab-pane label="" name="1">
				<el-card class="u-m-t-20" title="查验结果">
					<el-descriptions v-if="resultData.unit" :column="2" border style="margin-bottom: 20px">
						<el-descriptions-item label="企业名称">{{ resultData.unit.unitName }}</el-descriptions-item>
						<el-descriptions-item label="统一信用代码">{{ resultData.unit.unitCode }}</el-descriptions-item>
						<el-descriptions-item label="保单号">{{ resultData.policyNo }}</el-descriptions-item>
					</el-descriptions>
					<avue-crud ref="crud" :data="resultData.emps || []" :option="tableOption"></avue-crud>
					<div class="u-flex u-row-center u-m-t-30">
						<el-button type="primary" @click="onToBack">返回上一步</el-button>
					</div>
				</el-card>
			</el-tab-pane>
		</el-tabs>
	</basic-container>
</template>

<script>
import {checkPolicyTruth, getCode} from '@/api/insurance/product'
import {toYYYYmmddFullDate} from '@/util/date'

export default {
	data() {
		return {
			currentStep: '0',
			truthData: {
				unitName: '',
				policyNo: '',
			},
			truthOption: {
				emptyBtn: false,
				submitText: '查验保单',
				menuSpan: 24,
				column: [
					{
						label: '保单号',
						prop: 'policyNo',
						row: true,
						span: 16,
						offset: 3,
						rules: [
							{
								required: true,
								message: '请输入保单号',
								trigger: 'blur',
							},
						],
					},
					{
						label: '被保企业',
						prop: 'unitName',
						span: 16,
						offset: 3,
						row: true,
					},
					{
						label: '保障人员',
						prop: 'idnos',
						span: 16,
						offset: 3,
						row: true,
					},
					{
						label: '验证码',
						offset: 3,
						prop: 'code',
						rules: [
							{
								required: true,
								message: '请输入验证码',
								trigger: 'blur',
							},
						],
					},
				],
			},
			imageUrl: '',
			sn: '',
			isLoading: false,
			queryParams: {},
			tableOption: {
				border: true,
				menu: false,
				page: false,
				stripe: true,
				align: 'center',
				header: false,
				column: [
					{
						label: '姓名',
						prop: 'empName',
						width: 100,
					},
					{
						label: '身份证',
						prop: 'empIdNo',
					},
					{
						label: '查验结果',
						prop: 'status',
						type: 'select',
						width: 100,
						dicData: [
							{
								label: '已退保',
								value: 4000,
							},
							{
								label: '待生效',
								value: 4001,
							},
							{
								label: '保障中',
								value: 4002,
							},
							{
								label: '已过期',
								value: 4003,
							},
							{
								label: '未查询到此人',
								value: 4004,
							},
						],
					},
					{
						label: '工种',
						prop: 'categoryName',
						formatter: ({category: {categoryName, professionLevel}}) => {
							return `${categoryName}-${professionLevel}类`
						},
					},
					{
						label: '保障起期',
						prop: 'effectiveDate',
						formatter: ({effectiveDate}) => {
							return toYYYYmmddFullDate(effectiveDate)
						},
					},
					{
						label: '保障止期',
						prop: 'expiryDate',
						formatter: ({expiryDate}) => {
							return toYYYYmmddFullDate(expiryDate)
						},
					},
				],
			},
			resultData: {},
		}
	},
	created() {
		this.onGetCode()

		console.log(toYYYYmmddFullDate(1695139200000), '---')
	},
	methods: {
		onGetCode() {
			this.isLoading = true
			getCode()
				.then((res = {}) => {
					let {code = -1, data, params = {}} = res.data || {}
					if (code === 0) {
						this.imageUrl = data
						this.sn = params.sn || ''
					}
				})
				.finally(() => {
					this.isLoading = false
				})
		},
		onSubmit(formData, done) {
			let {policyNo = '', unitName = '', idnos = '', code} = formData
			policyNo = policyNo.trim()
			unitName = unitName.trim()
			idnos = idnos.trim()
			if (unitName === '' && idnos === '') {
				this.$message.error('请填写保障企业或者被保障人员进行查询')
				done()
				return
			}
			if (this.sn === '') {
				this.$message.error('验证码已过期！')
				this.onGetCode()
				return
			}
			//校验输入身份
			if (idnos !== '') {
				idnos = idnos.replace(/\s*/g, '')
				idnos = idnos.replaceAll(';', ',')
				idnos = idnos.replaceAll('；', ',')
			}
			//接口请求
			checkPolicyTruth({
				policyNo,
				unitName,
				idnos,
				code,
				sn: this.sn,
			})
				.then((res = {}) => {
					let {code = -1, data = {}, msg = ''} = res.data || {}
					if (code === 0) {
						this.resultData = data
						this.currentStep = '1'
						//恢复数据
						this.truthData.code = ''
						//重新调用验证码
						this.onGetCode()
					}
				})
				.catch(({message = ''}) => {
					if (message.includes('验证码')) {
						//恢复数据
						this.truthData.code = ''
						//重新调用验证码
						this.onGetCode()
					}
				})
				.finally(() => {
					done()
				})
		},
		//返回
		onToBack() {
			this.currentStep = '0'
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__nav-scroll {
	height: 0;
	width: 0;
}
</style>
